import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './Verify.css';

const Verify: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState<boolean | null>(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setLoading(false);
      setSuccess(false);
      setMessage('No verification token was provided. Please check the link in your email.');
      return;
    }

    const performVerification = async () => {
      try {
        await authService.verifyEmail(token);
        setSuccess(true);
        setMessage('Your email address has been successfully verified! You can now log in to access your dashboard.');
      } catch (error: any) {
        setSuccess(false);
        setMessage(error.response?.data?.message || 'Verification link is invalid or has expired. Please try requesting a new verification email.');
      } finally {
        setLoading(false);
      }
    };

    performVerification();
  }, [searchParams]);

  return (
    <div className="verify-container">
      <div className="verify-card">
        {loading && (
          <div className="verify-loading">
            <h1>🔮 Verifying Your Account</h1>
            <p>Please wait while we establish your cosmic alignment...</p>
            <LoadingSpinner />
          </div>
        )}

        {!loading && success === true && (
          <div className="verify-success">
            <div className="verify-icon success">✓</div>
            <h1>Email Verified!</h1>
            <p className="verify-message">{message}</p>
            <Link to="/login" className="verify-btn btn-primary">
              Proceed to Sign In
            </Link>
          </div>
        )}

        {!loading && success === false && (
          <div className="verify-failure">
            <div className="verify-icon failure">✗</div>
            <h1>Verification Failed</h1>
            <p className="verify-message">{message}</p>
            <div className="verify-actions">
              <Link to="/login" className="verify-btn btn-primary">
                Back to Sign In
              </Link>
              <Link to="/signup" className="verify-btn btn-secondary">
                Create New Account
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Verify;
